import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import PropTypes from 'prop-types';

/**
 * PageTitle
 */
const PageTitle = props => {
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "page-title-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-title-right"
  }, /*#__PURE__*/React.createElement(Breadcrumb, null, /*#__PURE__*/React.createElement(BreadcrumbItem, null, /*#__PURE__*/React.createElement(Link, {
    to: "/"
  }, "Home")), props.breadCrumbItems.map((item, index) => {
    return item.active ? /*#__PURE__*/React.createElement(BreadcrumbItem, {
      active: true,
      key: index
    }, item.label) : /*#__PURE__*/React.createElement(BreadcrumbItem, {
      key: index
    }, /*#__PURE__*/React.createElement(Link, {
      to: item.path
    }, item.label));
  }))), /*#__PURE__*/React.createElement("h4", {
    className: "page-title"
  }, props.title))));
};

export default PageTitle;